import { render } from "./EmtpyDashboard.vue?vue&type=template&id=65375cc9&scoped=true"
import script from "./EmtpyDashboard.vue?vue&type=script&lang=js"
export * from "./EmtpyDashboard.vue?vue&type=script&lang=js"

import "./EmtpyDashboard.vue?vue&type=style&index=0&id=65375cc9&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\PeD\\ApontaFacil\\dashboard\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65375cc9"]])

export default __exports__